import React from 'react'

const Header = ({ header }) => (
  <div className="row">
    <div className="small-12 columns">
      <h1 className="heading">{header.heading}</h1>
      <h2 className="subhead">{header.subhead}</h2>
      <div className="pill"></div>
      {header.body.map(paragraph => (
        <p className="sub-heading" key={paragraph} dangerouslySetInnerHTML={{__html: paragraph}}/>
      ))}
      <p className="sub-heading bold">{header.subtitleBold}</p>
    </div>
  </div>
)

export default Header
